import { EmergencyContact } from "@app/project/model/emergency-contact";
import { ApiResultState, LoadingState } from "@app/root-store/api-result.state";
import { ClareDbCollection } from "@app/shared/resources/resource-objectifier";
import { createReducer, on } from "@ngrx/store";
import { EmergencyContactActions } from "../actions";

export const emergencyContactFeatureKey = "emergency-contact";

export interface EmergencyContactState {
    activeProjectEmergencyContacts: ApiResultState<ClareDbCollection<EmergencyContact>>;
}

export const initialEmergencyContactState: EmergencyContactState = {
    activeProjectEmergencyContacts: {
        result: null,
        callState: LoadingState.init,
    },
};

export const emergencyContactReducer = createReducer(
    initialEmergencyContactState,
    on(EmergencyContactActions.clear, state => ({
        ...state,
        activeProjectEmergencyContacts: {
            ...state.activeProjectEmergencyContacts,
            result: null,
            callState: LoadingState.init,
        },
    })),
    on(EmergencyContactActions.load, state => ({
        ...state,
        activeProjectEmergencyContacts: {
            ...state.activeProjectEmergencyContacts,
            result: null,
            callState: LoadingState.loading,
        },
    })),
    on(EmergencyContactActions.loadSuccess, EmergencyContactActions.bulkUpdateSuccess, (state, { emergencyContacts }) => ({
        ...state,
        activeProjectEmergencyContacts: {
            ...state.activeProjectEmergencyContacts,
            result: emergencyContacts,
            callState: LoadingState.loaded,
        },
    })),
    on(EmergencyContactActions.createSuccess, EmergencyContactActions.updateSuccess, (state, { emergencyContact }) => ({
        ...state,
        activeProjectEmergencyContacts: {
            ...state.activeProjectEmergencyContacts,
            result: {
                ...state.activeProjectEmergencyContacts.result,
                [emergencyContact.id]: emergencyContact,
            },
            callState: LoadingState.loaded,
        },
    })),
    on(EmergencyContactActions.deleteSuccess, (state, { emergencyContact }) => {
        const newResult = { ...state.activeProjectEmergencyContacts.result };
        delete newResult[emergencyContact.id];
        return {
            ...state,
            activeProjectEmergencyContacts: {
                ...state.activeProjectEmergencyContacts,
                result: newResult,
                callState: LoadingState.loaded,
            },
        };
    }),
    on(EmergencyContactActions.deleteAllSuccess, state => ({
        ...state,
        activeProjectEmergencyContacts: {
            ...state.activeProjectEmergencyContacts,
            result: {},
            callState: LoadingState.loaded,
        },
    }))
);
